

/* BEGIN compact-edc-pouch-buyer-highlights-20260731 */
;(function () {
  var expected = ["Water-resistant 900D polyester, a military-standard SBS zipper, and a secure KAM buckle provide durable construction and reliable access to daily essentials.","A detachable armband and extra-wide belt loop support arm or waist carry, while the removable lanyard adjusts from 27–38 cm (10.5–15 in) and includes a detachable buckle.","A suede-lined interior compartment protects a mobile phone, and the organized main compartment keeps compact gear easy to access."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-compact-edc-pouch-utility-gadget-wallet-fit-6-3-phone-belt-bag') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END compact-edc-pouch-buyer-highlights-20260731 */
